<div class="container-fluid">
  <div class="row">
    <div class="col-md-10 page-heading">
      <h4>Undocumented Immigrants</h4>
      <p>Manage all undocumented immigrants</p>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="bgWhite noMargin w100">
    <div class="row">
      <div class="col-md-12 px-0">
        <div class="row tab-container">
          <div class="col-2  tab-label tab-height" (click)="toggleMode('INTEREST')"
            [ngClass]="{'activeTimeLine': toggleStatus === 'INTEREST' }">
            <div class="lbl-text">Beneficiaries Shown Interest ({{ interestedBeneficiariesRecordCount }})</div>
          </div>
          <div class="col-2  tab-label tab-height" (click)="toggleMode('POOL')"
            [ngClass]="{'activeTimeLine': toggleStatus === 'POOL'}">
            <div class="lbl-text">Beneficiary Pool ({{ beneficiariesPoolRecordCount }})</div>
          </div>
          <div class="col-5"></div>
          <button class="mr-2 mt-2 btn btn-primary" pButton type="button" *ngIf="toggleStatus != 'INTEREST'" [disabled]="selectedBeneficiaryPoolArray.length == 0"
          (click)="openFormModal('Send Info')" pTooltip="Send Info">Send Info</button>
          <div class="search-btn">
            <!-- <button type="text" class="taskFilter-btn" pButton label="Filter" (click)="filterPanel.toggle($event)"
            icon="pi pi-filter" iconPos="right"> </button> -->

            <div class="input-group search-text">
              <input class="form-control im-pt-3 pr-5" #searchBeneficiaryListTable (search)="resetSearch()" type="search"
                placeholder="Search">
              <span class="input-group-append">
                <button class="btn rounded-pill ml-n4r" title="search" type="button">
                  <i class="fa fa-search border-0" alt=""></i>
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="!displayDetails">
      <p-table [columns]="cols" class="pa-table im-card-no-border-table im-card-table-noborder-spacing table"
      styleClass="p-datatable-gridlines" [value]="interestedBeneficiaries" dataKey="id" *ngIf="toggleStatus == 'INTEREST' && interestedBeneficiariesRecordCount > 0">
      <ng-template pTemplate="header" let-columns>
        <tr class="text-uppercase">
          <th *ngFor="let col of columns">
            {{col.header}}
          </th>
          <th>Action </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td><button class="p-button-text" pButton type="button"  (click)="beneficiaryDetails(item)">{{item?.beneficaryName}}</button></td>
          <td>{{item?.citizenship}}</td>
          <td>{{item?.country}}</td>
          <td>{{item?.degree}}</td>
          <td>
            <button pButton type="button"  (click)="openFormModal('Send Invite',item)" pTooltip="Send Invite"
              class="p-button-text">Send Invite</button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6">No Data</td>
        </tr>
      </ng-template>
      </p-table>
      <p-table [columns]="cols" [(selection)]="selectedBeneficiaryPoolArray" class="pa-table im-card-no-border-table im-card-table-noborder-spacing table"
      styleClass="p-datatable-gridlines" [value]="beneficiariesPool" dataKey="beneficiaryId" *ngIf="toggleStatus != 'INTEREST' && beneficiariesPoolRecordCount > 0">
      <ng-template pTemplate="header" let-columns>
        <tr class="text-uppercase">
          <th style="width: 3rem">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th *ngFor="let col of columns">
            {{col.header}}
          </th>
          <th>Action </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>
            <p-tableCheckbox [value]="item"></p-tableCheckbox>
          </td>
          <td><button class="p-button-text" pButton type="button"  (click)="beneficiaryDetails(item)">{{item?.beneficaryName}}</button></td>
          <td>{{item?.citizenship}}</td>
          <td>{{item?.country}}</td>
          <td>{{item?.degree}}</td>
          <td>
            <button pButton type="button"  (click)="openFormModal('Send Info',item)" pTooltip="Send Info"
              class="p-button-text">Send Info</button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6">No Data</td>
        </tr>
      </ng-template>
      </p-table>

      <div *ngIf="toggleStatus == 'INTEREST' && interestedBeneficiariesRecordCount == 0" class="mt-4 text-center">No Data</div>
      <div *ngIf="toggleStatus != 'INTEREST' && beneficiariesPoolRecordCount == 0" class="mt-4 text-center">No Data</div>

      <p-paginator [rows]="pageSize" (onPageChange)="paginationEvent($event)" *ngIf="toggleStatus == 'INTEREST' && interestedBeneficiariesRecordCount > 0"
        [totalRecords]="interestedBeneficiariesRecordCount" [rowsPerPageOptions]="pageSizeOptions" length="totalElementCount">
      </p-paginator>
      <p-paginator [rows]="pageSize" (onPageChange)="paginationEvent($event)" *ngIf="toggleStatus != 'INTEREST' && beneficiariesPoolRecordCount > 0"
        [totalRecords]="interestedBeneficiariesRecordCount" [rowsPerPageOptions]="pageSizeOptions" length="totalElementCount">
      </p-paginator>
    </div>

    <div *ngIf="displayDetails">
      <app-display-information [beneficiaryIdInput]="beneficiaryId"></app-display-information>
      </div>

</div>
</div>  